export default "__VITE_ASSET__7246a0b0__"